// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1KfpI","consentsList":"PatientConsents_consentsList___r03y","consentsListEmpty":"PatientConsents_consentsListEmpty__39QA8"};